module.exports = __webpack_public_path__ + "static/people_pop30-4a34d0c553af6c0631d616fe832dd138.png";